import { SectionShell, Field } from "./SectionShell";
import { Input } from "../ui/input";
import { Textarea } from "../ui/textarea";
import { inputCls } from "./constants";

const TOOL_FIELDS = [
  ["email", "Email"], ["calendar", "Calendar"], ["project_management", "Project Management"],
  ["crm", "CRM"], ["marketing", "Marketing Platforms"], ["design", "Design Tools"],
  ["communication", "Communication"], ["accounting", "Accounting"], ["other", "Other"],
];

export default function ToolsTab({ data, update, onVoice }) {
  const setTool = (key, value) => update({ tool_stack: { ...data.tool_stack, [key]: value } });
  return (
    <SectionShell eyebrow="Section 3 · 8 min" title="Current Tool Stack" voiceSection="tool_stack" onVoice={onVoice}>
      <div className="grid md:grid-cols-2 gap-5">
        {TOOL_FIELDS.map(([k, l]) => (
          <Field key={k} label={l}>
            <Input data-testid={`tool-${k}`} className={inputCls} value={data.tool_stack?.[k] || ""} onChange={(e) => setTool(k, e.target.value)} />
          </Field>
        ))}
      </div>
      <div className="mt-8 space-y-5">
        <Field label="Tools They Love">
          <Textarea data-testid="tools-love" className={inputCls} rows={2} value={data.tool_stack?.tools_they_love || ""} onChange={(e) => setTool("tools_they_love", e.target.value)} />
        </Field>
        <Field label="Tools They Tolerate / Hate">
          <Textarea data-testid="tools-hate" className={inputCls} rows={2} value={data.tool_stack?.tools_they_hate || ""} onChange={(e) => setTool("tools_they_hate", e.target.value)} />
        </Field>
        <Field label="Tools Paying For But Barely Using">
          <Textarea data-testid="tools-wasted" className={inputCls} rows={2} value={data.tool_stack?.tools_wasted || ""} onChange={(e) => setTool("tools_wasted", e.target.value)} />
        </Field>
        <Field label="AI Tool Experience">
          <Textarea data-testid="tools-ai-exp" className={inputCls} rows={2} value={data.tool_stack?.ai_tool_experience || ""} onChange={(e) => setTool("ai_tool_experience", e.target.value)} />
        </Field>
      </div>

      <div className="mt-10 pt-8 border-t border-navy/10">
        <div className="eyebrow text-gold mb-2">Lead Funnel & Automation</div>
        <p className="text-xs text-navy/60 mb-5">Powers the Lead Funnel Snapshot and Automation Opportunity Map documents.</p>
        <div className="space-y-5">
          <Field label="Where do your leads come from today?">
            <Textarea data-testid="funnel-lead-sources" className={inputCls} rows={2} value={data.tool_stack?.lead_sources || ""}
              onChange={(e) => setTool("lead_sources", e.target.value)}
              placeholder="Paid (Google/Meta), organic (SEO/social), referral, partner, events — mark which are working." />
          </Field>
          <Field label="Who responds to new leads, how fast, with what tool?">
            <Textarea data-testid="funnel-response-process" className={inputCls} rows={2} value={data.tool_stack?.current_response_process || ""}
              onChange={(e) => setTool("current_response_process", e.target.value)}
              placeholder="Owner / team / VA · response SLA · email/SMS/phone · consistency." />
          </Field>
          <Field label="Walk through how a lead moves through your CRM/pipeline.">
            <Textarea data-testid="funnel-pipeline" className={inputCls} rows={2} value={data.tool_stack?.crm_pipeline_process || ""}
              onChange={(e) => setTool("crm_pipeline_process", e.target.value)}
              placeholder="Stages, who moves them, manual vs automated, reporting visibility." />
          </Field>
          <Field label="Where are leads getting dropped or not nurtured?">
            <Textarea data-testid="funnel-gaps" className={inputCls} rows={2} value={data.tool_stack?.follow_up_gaps || ""}
              onChange={(e) => setTool("follow_up_gaps", e.target.value)}
              placeholder="No-show recovery, missed follow-ups, dead leads, no nurture sequence." />
          </Field>
          <Field label="What automations are already running?">
            <Textarea data-testid="funnel-existing-automation" className={inputCls} rows={2} value={data.tool_stack?.existing_automation || ""}
              onChange={(e) => setTool("existing_automation", e.target.value)}
              placeholder="Zapier, Make, n8n, GHL workflows, custom builds — what's working, what's broken." />
          </Field>
        </div>
      </div>
    </SectionShell>
  );
}
